export function formatRoleLabel(role) {
  if (!role) return '-';

  const normalized = String(role).trim();
  if (!normalized) return '-';
  if (normalized.toLowerCase() === 'csr') return 'CSR';

  return normalized
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function normalizeRole(role) {
  return String(role || '')
    .trim()
    .toLowerCase();
}

export function resolvePrimaryRole(user) {
  if (!user || typeof user !== 'object') return '';

  return (
    user.role ||
    user.user_role ||
    (Array.isArray(user.roles) ? user.roles[0] : '') ||
    ''
  );
}

export function getUserRoles(user) {
  if (!user || typeof user !== 'object') return [];

  return Array.from(
    new Set(
      [user.role, user.user_role, ...(Array.isArray(user.roles) ? user.roles : [])]
        .filter(Boolean)
        .map((role) => normalizeRole(role))
        .filter(Boolean)
    )
  );
}

export function hasRole(user, role) {
  if (!role) return false;
  return getUserRoles(user).includes(normalizeRole(role));
}

export function isBuyerRole(role) {
  return normalizeRole(role) === 'buyer';
}

export function isSellerRole(role) {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'shop_owner' || normalizedRole === 'employee';
}

export function isDispatcherRole(role) {
  const normalizedRole = normalizeRole(role);
  return normalizedRole === 'dispatcher_owner' || normalizedRole === 'dispatch_employee';
}

export function isSellerUser(user) {
  return isSellerRole(resolvePrimaryRole(user));
}

export function userHasSellerRole(user) {
  const roles = getUserRoles(user);
  return roles.includes('shop_owner') || roles.includes('employee');
}

export function formatUserRoleLabel(user) {
  return formatRoleLabel(resolvePrimaryRole(user));
}
